import { useLocation } from "react-router";

export function useIsTopPage() {
  const location = useLocation();
  return location.pathname === "/";
}
